export default {
  generalTerms: {
    title: 'General terms and conditions',
    }
  }
